import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, computed, EventEmitter, input, OnChanges, Output, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';

@Component({
    selector: 'r1-compass-lib-error-table',
    imports: [MatPaginatorModule, MatSortModule, MatTableModule],
    templateUrl: './error-table.component.html',
    styleUrl: './error-table.component.scss',
    animations: [
        trigger('detailExpand', [
            state('collapsed, void', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class ErrorTableComponent implements OnChanges {
    public errorData = input.required<ErrorTableData[]>();
    public columnsToDisplay = input.required<{ property: string; label: string }[]>();

    protected dataSource = new MatTableDataSource<ErrorTableData>([]);
    protected pageSize = 10;

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatTable) table!: MatTable<ErrorTableData>;
    @ViewChild(MatSort) sort!: MatSort;

    @Output()
    pageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

    protected columnNames = computed<string[]>(() => this.columnsToDisplay().map(c => c.property));

    ngOnChanges(): void {
        this.dataSource.data = this.errorData();
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    onPageChange(pageEvent: PageEvent) {
        this.pageChange.emit(pageEvent);
    }
}

export type ErrorTableData = {
    startDate: string;
    endDate?: string;
    elapsedSeconds?: number;
    error: string;
    errorType?: string;
};
